import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_EZP } from '$Deposits/store/actions/DepositPost'
import { EZP_Submit } from '$Deposits/store/actions/DepositEvent'



class EZP extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            SetDepositPayments_EZP,
            DepositNextStep,
            DepositSuccessPage,
            AvailableMethods,
            MoneyInput,
            SubmitBtn,
            NextStep,
            SuccessPage,
            BankSelect,
        } = this.props

        return (
            <>
                {
                    !DepositNextStep && !DepositSuccessPage &&
                    <>
                        <AvailableMethods />
                        <MoneyInput />
                        <BankSelect />
                        <SubmitBtn
                            submitBtn={EZP_Submit}
                            onPress={() => { SetDepositPayments_EZP() }}
                            submitBtnItem={'ถัดไป'}
                        />
                    </>
                }
                {
                    DepositNextStep &&
                    <NextStep />
                }
                {
                    DepositSuccessPage &&
                    <SuccessPage countdownTime={600} />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
});
const mapDispatchToProps = {
    SetDepositPayments_EZP: (data = {}) => SetDepositPayments_EZP(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(EZP);


